<template>
  <div v-if="!invalidEditParam" >
    <v-toolbar-title class='display-1 fontcolor'>Country: {{ editedItem.name }}</v-toolbar-title>
    <v-toolbar flat id='manageTable'>
      <v-spacer></v-spacer>
      <v-btn class="mr-4" outlined dark color='red' @click='backToListingPage'>
        <v-icon dark>mdi-arrow-left</v-icon>Back to list
      </v-btn>
    </v-toolbar>
    <v-tabs v-model="activeTab" class="locationTabsCnt tab-selected-map" >
      <v-tab key='1' >PROFILE</v-tab>
      <v-tab key='2' >ADOPTION ACTIVITY</v-tab>
      <!-- Tab #1 for profile starts -->
      <v-tab-item>
        <v-card class="pl-7 pr-6 pt-5 pb-5 noCardBorder" >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col>
                <v-text-field v-model='editedItem.name' :rules="countryRules" :maxlength='max'
                  hint='Please enter country name. Only characters (A-Z, a-z) and space is allowed.'
                  label='Country Name*' validate-on-blur>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model='editedItem.abbreviation'
                  hint='Please enter abbreviation for the country. Only characters (A-Z) is allowed.'
                  :maxlength="max" label='Abbreviation'>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model='editedItem.code'
                  hint='Please enter UN Code for the country. Only numbers (0-9) is allowed.'
                  :rules="codeRules" :maxlength="max" label='UN Code'>
                </v-text-field>
              </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    v-model='editedItem.status'
                    :items="statusItems"
                    label="Status*"
                    :rules="statusValidationRules"
                    item-text="statusText"
                    item-value="statusVal"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <small color="primary" class="subtitle-1 pb-5">Adoptions</small>
                  <editor
                    :key="editedItem.id"
                    :editor-text="editedItem.adoption"
                    :on-update="(updatedAdoption) => { editedItem.adoption = updatedAdoption }"
                  ></editor>
                </v-col>
              </v-row>
            <!-- Below fields will view only on edit state form.
                All below fields will be in disable mode.
              -->
            <v-row >
            <v-col>
                <v-text-field disabled v-model='editedItem.createdBy'
                label='Created By'></v-text-field>
              </v-col>
            </v-row>
            <v-row >
              <v-col>
                <v-text-field disabled v-model='editedItem.createdDate'
                label='Created On'></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="editedItem.createdDate !== editedItem.modifiedDate" >
              <v-col>
                <v-text-field disabled v-model='editedItem.modifiedBy'
                label='Modified By'></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="editedItem.createdDate !== editedItem.modifiedDate" >
              <v-col>
                <v-text-field disabled v-model='editedItem.modifiedDate'
                label='Modified On'></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <small color="primary">*indicates required fields</small>
              <v-spacer></v-spacer>
              <!-- <v-btn outlined dark color='red' @click='backToListingPage'>
                <v-icon dark>mdi-arrow-left</v-icon>Back
              </v-btn> -->
              <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                <v-icon dark>mdi-check</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-tab-item>
      <!-- Tab #1 for profile end -->
      <!-- Tab #2 for adotion activity starts -->
      <v-tab-item>
        <div class="pt-5" style="border-top:1px solid #e2e3e1" >
          <admin-activity-by-entity
          :entityTitle="editedItem.name"
          :adoptionLevel = '5'
          :name = 'editedItem.name'
          >
          </admin-activity-by-entity>
        </div>
      </v-tab-item>
      <!-- Tab #2 for adoption activity ends -->
    </v-tabs>
  </div>
  <div v-else>
    <h1 class="mt-6 text-center" >Invalid edit parameter!</h1>
  </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import AdminActivityByEntity from './../activitybyentities/ActivityByEntity'
import Editor from '../../Common/Editor.vue'
export default {
  name: 'AdminEditCountry',
  components: {
    'editor': Editor,
    'admin-activity-by-entity': AdminActivityByEntity
  },
  data: () => ({
    activeTab: 1,
    auditLogLoader: true,
    isEditing: false,
    btnLoader: false,
    invalidEditParam: false,
    valid: true,
    max: 50,
    mx: 2,
    maxAbbreviation: 5,
    abbreviationRules: [v => !!v || 'Abbreviation is required.'],
    countryRules: [v => !!v || 'Country name is required.',
      v => /^[A-Za-z ]+$/.test(v) || 'Invalid input. Only characters (A-Z, a-z) allowed!'],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    codeRules: [v => {
      if (v && v.length < 3 && v.length > 5) {
        return 'Please enter a unique  3-5 digit numeric UN Code.'
      } else {
        return true
      }
    },
    v => {
      if (v && !/.[0-9]./.test(v)) {
        return 'Please enter a unique  3-5 digit numeric UN Code.'
      } else {
        return true
      }
    }
    ],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    editedItem: {
      name: '',
      abbreviation: '',
      code: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      status: '',
      adoption: ''
    },
    currentCountryId: ''
  }),
  mounted () {
    this.activeTab = (this.$globalFromValidation.paramIsInNumFormat(this.$route.params.tabId) - 1)
    this.initialize()
  },
  computed: {
    activityLogs () {
      return this.activityLogItems
    },
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    editedStateId () {
      return this.currentCountryId
    }
  },
  methods: {
    initialize () {
      /**
       * Check if id is valid number of not else set a invalid parama flag true
       */
      let idToGetInfo = this.$globalFromValidation.paramIsInNumFormat(this.$route.params.id)
      if (idToGetInfo > 0) {
        // Fetch data by id for edit
        new Promise((resolve, reject) => {
          this.$store.dispatch('CountryModule/getCountryDetailsById', { resolve, reject, idToGetInfo })
        }).then((responseData) => {
          this.editedItem = Object.assign({}, responseData.list[0])
          this.currentCountryId = idToGetInfo
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.invalidEditParam = true
        })
      } else {
        this.invalidEditParam = true
      }
    },
    /**
     * Function to send user back to listing page
     */
    backToListingPage () {
      this.$router.push({ name: 'AdminCountries' })
    },
    save () {
      this.btnLoader = true
      if (this.$refs.form.validate()) {
        Object.assign(this.editedItem)
        let editCountryData = this.editedItem
        const editedData = {
          adoption: editCountryData.adoption,
          adoptionId: editCountryData.adoptionId,
          name: editCountryData.name,
          abbreviation: editCountryData.abbreviation.toUpperCase(),
          code: editCountryData.code,
          status: editCountryData.status,
          userId: this.userId,
          id: Number(editCountryData.id)
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('CountryModule/editCountryItem', { resolve, reject, editedData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.initialize()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
      } else {
        this.btnLoader = false
      }
    }
  }
}
</script>
